import { render, staticRenderFns } from "./LogoSlogan.vue?vue&type=template&id=6a477337"
import script from "./LogoSlogan.vue?vue&type=script&lang=js"
export * from "./LogoSlogan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports